import React from "react";
import { useTheme } from "../context/ThemeContext";

const StatCard = ({ title, value, details, icon }) => {
  const { isDarkMode } = useTheme();

  const cardClasses = isDarkMode
    ? "bg-black border-zinc-900 hover:border-zinc-800 text-white"
    : "bg-white border-gray-200 hover:border-gray-300 text-gray-900 shadow-md";

  const titleTextClass = isDarkMode ? "text-gray-500" : "text-gray-600";

  const valueTextClass = isDarkMode ? "text-white" : "text-gray-900";

  const detailsTextClass = isDarkMode ? "text-gray-500" : "text-gray-600";

  return (
    <div
      className={`rounded-xl p-5 flex flex-col gap-3 border transition-colors duration-300 hover:border-opacity-70 ${cardClasses}`}
    >
      <div className="flex items-center justify-between">
        <h3 className={`text-sm font-medium ${titleTextClass}`}>{title}</h3>
        {icon}
      </div>

      <div className={`text-3xl font-bold ${valueTextClass}`}>{value}</div>

      {details && (
        <div className={`flex gap-3 text-xs ${detailsTextClass}`}>
          {details.map((detail, idx) => (
            <span key={idx}>{detail}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatCard;
